<template>
  <v-container>
    <v-row>
      <v-col>
        <v-combobox
          item-text="name"
          item-value="state_id"
          :return-object="true"
          :items="stateList"
          v-model="stateSelect"
          :search-input.sync="searchState"
          label="States"
          outlined
          dense
          class="city-creator"
        ></v-combobox>
      </v-col>
      <v-col>
        <v-text-field dense v-model="city" class="city-creator" label="Enter City" outlined></v-text-field>
      </v-col>
      <v-col>
        <v-card class="mx-auto" max-width="400">
          <v-card-title class="white--text green darken-4">
            Create ZIP
            <v-spacer></v-spacer>

            <v-btn color="orange" class="text--primary" @click="createZip" fab x-small>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-virtual-scroll :items="items" :min-width="250" :item-height="50" height="300">
            <template v-slot="{ item }">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ item.value }}</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn depressed small @click="editZip(item)">
                    Edit ZIP
                    <v-icon color="orange darken-4" right>mdi-open-in-new</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-col>
    </v-row>
    <zip-edit
      v-if="editZipAction"
      :data-zip="zipItemEdit"
      :data-action="editZipAction"
      @close-dialog="closeDialog"
    />
    <zip-creater
      v-if="createZipAction"
      :data-zip="zipItemCreate"
      :data-action="createZipAction"
      @close-dialog="closeDialog"
      @save-creater="saveCreater"
    />
  </v-container>
</template>
<script>
import ZipEdit from "./edit-zip/edit-zip.component";
import ZipCreater from "./create-zip/create-zip.component";

export default {
	components: {
		ZipEdit,
		ZipCreater,
	},
	props: [ "data-items" ],
	data() {
		return {
			itemsZip: [],
			stateList: [],
			zipItemEdit: null,
			zipItemCreate: null,
			editZipAction: false,
			createZipAction: false,
			flagAddress: false,
			searchState: null
		};
	},
	computed: {
		address() {
			return this.dataItems;
		},
		items() {
			return this.dataItems.city.zip;
		},
		city: {
			get: function() {
				return this.dataItems.city.city;
			},
			set: function(val) {
				this.dataItems.city.city = val;
			},
		},
		stateSelect: {
			get: function() {
				return {
					name: this.dataItems.city.state,
					state_id: this.dataItems.city.state_id,
				};
			},
			set: function(val) {
				if (typeof val != 'string') {
					this.dataItems.city.state = val.name;
					this.dataItems.city.state_id = val.state_id;
				} else {
					this.dataItems.city.state = null;
					this.dataItems.city.state_id = null;
				}
			},
		},
	},
	mounted() {
		this.getStates();
	},
	methods: {
		closeDialog() {
			this.editZipAction = false;
			this.zipItemEdit = null;
			this.createZipAction = false;
			this.zipItemCreate = null;
		},
		saveCreater() {
			this.items.unshift(this.zipItemCreate);
			this.closeDialog();
		},
		getStates() {
			this.$store.dispatch("actionPreloader", true);
			this.$store.dispatch("getStates").then(() => {
				this.$store.dispatch("actionPreloader", false);
				this.stateList = this.$store.getters.getStates.states;
			});
		},
		editZip(item) {
			this.zipItemEdit = item;
			this.editZipAction = true;
		},
		createZip() {
			this.zipItemCreate = { di: null, value: null };
			this.createZipAction = true;
		},
	},
};
</script>
<style lang="scss" scoped>
@import "./city.component";
</style>
